import { requestWithToken } from "../helper/helper";
  
export const fetchAllLanguages = async () => {
  try {
    const response = await requestWithToken(
      "GET",
      `/language/list`
    );  

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};